import { Component, OnInit, inject } from '@angular/core';
import { PatientInteractionLocationsService } from 'app/core/services/patient-interaction-locations.service';
import { PatientInteractionLocation } from 'app/core/models/patient-interaction-location.model';
import { PatientInteractionLocationEligibilityStatus } from 'app/core/enums/patient-interaction-location-eligibility-status.enum';
import {
  PatientInteractionLocationFilters,
} from 'app/core/models/user-settings/patient-interaction-location-settings.model';
import { LimitOffsetPaging } from 'app/core/models/paged-results/limit-offset-paging.model';

import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { PatientInteractionLocationListComponent } from '../../../shared/components/patient-interaction-location-list/patient-interaction-location-list.component';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-patient-interaction-locations-new-locations-section',
    templateUrl: './patient-interaction-locations-new-locations-section.component.html',
    imports: [PaginationHeaderComponent,
              PatientInteractionLocationListComponent,
              PaginationComponent,
              MatProgressSpinner]
})
export class PatientInteractionLocationsNewLocationsSectionComponent implements OnInit {
  private patientInteractionLocationsService = inject(PatientInteractionLocationsService);

  patientInteractionLocations: PatientInteractionLocation[] = [];
  loading = true;
  paging: LimitOffsetPaging = LimitOffsetPaging.empty;

  constructor() {
    this.paging.pageSize = 20;
  }

  ngOnInit() {
    this.loadPatientInteractionLocations();
  }

  onPageChange(_page: number) {
    this.loadPatientInteractionLocations();
  }

  onPageSizeChange(size: number) {
    this.paging.pageSize = size;
    this.loadPatientInteractionLocations();
  }

  private loadPatientInteractionLocations() {
    const filters = new PatientInteractionLocationFilters();
    filters.eligibilityStatuses = [PatientInteractionLocationEligibilityStatus.new];

    this.patientInteractionLocationsService.getList(this.paging, filters).subscribe(result => {
      this.patientInteractionLocations = result.patientInteractionLocations;
      this.paging = result.meta.paging;
      this.loading = false;
    });
  }
}
